import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { noticeDyx, getNoticeSetting, saveNoticeSetting } from '@/services/product/notice';
import { getSpecDetailList } from '@/services/cardrecommend';
import { getProductList } from '@/services/productDetail';
import { getSellerList } from '@/services/customer/erpCustomerList';
import selectGroupVue from '@/components/commonAdd/selectGroupDyx.vue';
import FooterToolBar from '@/components/tool/FooterToolBar';
import erpCustomerMixin from "@/utils/vue-functions/erpCustomerMixin";

/** 得意先状态
 * @readonly
 * @enum
 * */
var ErpCustomerStatus = {
  /** 正常 */
  NORMAL: 1,
  /** 删除 */
  DELETED: 2,
  /** 取引终了 */
  END: 3
};
export default {
  i18n: require('./i18n-notice'),
  mixins: [erpCustomerMixin],
  components: {
    selectGroupVue: selectGroupVue,
    FooterToolBar: FooterToolBar
  },
  data: function data() {
    this.handleSearch = _.debounce(this.handleSearch, 600);
    return {
      queryParam: {
        /**
         * 通知id，新建时传空
         */
        noticeId: '',
        /**
         * 通知名称
         */
        noticeName: '',
        //

        /**
         * 担当者code，多个逗号分隔
         */
        selllerCode: [],
        //
        /**
         * 担当者名称，多个逗号分隔
         */
        selllerName: '',
        page: 1,
        size: 5
      },
      sellerOptions: [],
      // 担当者列表options
      productList: [],
      // 商品列表
      addProductVisible: false,
      // 添加商品弹窗 visible
      addProductFetching: false,
      // 添加商品弹窗 获取数据 loading
      addProudctList: [],
      // 添加商品弹窗 商品列表
      addProudctSaveLoading: false,
      datavalue: {
        //
        id: undefined
      },
      rules: {
        id: [{
          required: true,
          message: this.$t('public.enterPlease') + this.$t('publicuse.goodsno'),
          trigger: 'blur'
        }]
      },
      // 通知对象表格列
      noticeTableColumns: [{
        title: this.$t('arrivalNotice.dyxInfo'),
        //得意先信息
        dataIndex: 'dyxInfo',
        key: 'title',
        width: '20%',
        ellipsis: true,
        scopedSlots: {
          customRender: 'dyxInfo' //自定义表格里面的内容
        }
      }, {
        title: this.$t('arrivalNotice.dyxStatus'),
        //得意先状态
        dataIndex: 'erpCustomerStatus',
        key: 'erpCustomerStatus',
        width: '20%',
        ellipsis: true,
        scopedSlots: {
          customRender: 'erpCustomerStatus' //自定义表格里面的内容
        }
      }, {
        title: this.$t('arrivalNotice.busFormat'),
        //业态
        dataIndex: 'busFormatName',
        key: 'busFormatName',
        width: '20%',
        ellipsis: true,
        scopedSlots: {
          customRender: 'busFormatName' //自定义表格里面的内容
        }
      }, {
        title: this.$t('arrivalNotice.seller'),
        //担当者
        dataIndex: 'sellerName',
        key: 'sellerName',
        width: '20%',
        ellipsis: true,
        scopedSlots: {
          customRender: 'sellerName' //自定义表格里面的内容
        }
      }, {
        title: this.$t('arrivalNotice.noticeType'),
        //通知方式
        dataIndex: 'noticeType',
        key: 'noticeType',
        width: '20%',
        ellipsis: true,
        scopedSlots: {
          customRender: 'noticeType' //自定义表格里面的内容
        }
      }, {
        title: this.$t('arrivalNotice.noticeTime'),
        //通知时间
        dataIndex: 'noticeDate',
        key: 'noticeDate',
        width: '20%',
        ellipsis: true,
        scopedSlots: {
          customRender: 'noticeDate' //自定义表格里面的内容
        }
      }, {
        title: this.$t('arrivalNotice.action'),
        //操作
        dataIndex: 'action',
        key: 'action',
        width: '20%',
        ellipsis: true,
        scopedSlots: {
          customRender: 'action' //自定义表格里面的内容
        }
      }],
      // 通知方式类型
      noticeTypes: {
        1: 'WeChat',
        2: 'Line',
        3: 'メール'
      },
      dyxList: [],
      // 通知对象表格数据
      listTotal: 0,
      // 通知对象表格数据总数

      noticeTableLoading: false,
      // 通知对象表格 loading

      alreadySelect: [],
      // 已经选择的得意先
      selectedRowKeys: [],
      // 通知对象表格数据选择的row
      removeTypeVisible: false,
      // 批量删除弹窗 visible
      modalValue: {
        // 批量删除类型
        removeType: 0
      },
      selectNumber: 0,
      // 选中的得意先数量
      selectCustomerList: [],
      //通知对象表格数据 选择的得意先
      crrentPageProductList: [],
      // 当前页的通知对象表格数据
      noticeSaveLoading: false,
      // 保存到货通知 loading

      moreNoticeForm: {
        // 批量通知类型 form
        noticeType: 0
      },
      moreNoticeVisible: false,
      //批量通知model visible
      noticeLoading: false,
      // 批量通知loading
      noticeSettingData: null,
      // 到货通知数据
      noticeDyxLoading: false
    };
  },
  created: function created() {
    if (this.$route.query.noticeid) {
      this.queryParam.noticeId = this.$route.query.noticeid;
      this.getNoticeData();
    }
    this.getSellerListData();
    console.log('this', this);
  },
  watch: {
    selectCustomerList: function selectCustomerList() {
      // console.log(this.selectCustomerList)
      this.selectNumber = this.selectCustomerList.length;
    }
  },
  computed: {
    /**
    * 过滤出删除的得意先列表
    * @return {[type]} [description]
    */
    // filteredNoticeTableData(){
    //    console.log('computed filteredNoticeTableData')
    //   return this.dyxList.filter(dyx => dyx.deletflag !== 1)
    // },
    selectedTypes: function selectedTypes() {
      return {
        Selected: 0,
        // '勾选得意先',
        CurrentPage: 1,
        // '当前页',
        AllPage: 2 // '全部页'
      };
    },
    currentPageProductList: function currentPageProductList() {
      var data = _toConsumableArray(this.dyxList);
      return data.splice((this.queryParam.page - 1) * this.queryParam.size, this.queryParam.size);
    }
  },
  methods: {
    // 点击通知
    handleMoreNotice: function handleMoreNotice() {
      this.moreNoticeForm.noticeType = this.selectedTypes.Selected;
      this.moreNoticeVisible = true;
    },
    // 点击删除 /点击批量删除
    removeModal: function removeModal(record) {
      this.crrentPageProductList = this.currentPageProductList;
      this.removeErpCustomers(record);
    },
    /**
     * 判断得意先是否可以选中
     */
    getCheckboxProps: function getCheckboxProps(record) {
      return {
        props: {
          disabled: !record.noticeType || !!record.noticeDate || record.erpCustomerStatus !== ErpCustomerStatus.NORMAL // 如果没有通知方式或者通知过或者得意先状态不是正常的,就禁止选中
        }
      };
    },
    /**
     * 获取到货通知数据
     * @return {[type]} [description]
     */
    getNoticeData: function getNoticeData() {
      var _this = this;
      var params = {};
      getNoticeSetting(this.queryParam.noticeId, params).then(function (res) {
        return res.data;
      }).then(function (res) {
        if (res.code === 200) {
          if (!_.isObject(res.data)) {
            console.warn('获取到货通知接口返回的data为空 res', res);
            return;
          }
          _this.noticeSettingData = res.data;
          _this.queryParam.noticeId = res.data.noticeId;
          _this.queryParam.noticeName = res.data.noticeName;
          if (_.isString(res.data.selllerCode)) {
            _this.queryParam.selllerCode = res.data.selllerCode.split(',');
          } else {
            console.warn('获取到货通知接口返回的担当者code 不是一个字符串 res', res);
          }
          _this.productList = res.data.productlist || [];
          _this.dyxList = res.data.erpcustomerlist || [];
          if (_.isArray(_this.dyxList)) {
            _this.listTotal = _this.dyxList.length;
            _this.alreadySelect = _this.dyxList.map(function (dyx) {
              return dyx.erpCustomerId;
            });
          }
        }
      });
    },
    /**
     * 批量通知弹窗 确定
     * @return {[type]} [description]
     */
    moreNotice: function moreNotice() {
      var noticedDyx = [];
      if (this.moreNoticeForm.noticeType == this.selectedTypes.Selected) {
        noticedDyx = _.cloneDeep(this.selectCustomerList);
      } else if (this.moreNoticeForm.noticeType == this.selectedTypes.CurrentPage) {
        noticedDyx = _.cloneDeep(this.currentPageProductList);
      } else {
        noticedDyx = _.cloneDeep(this.dyxList);
      }

      // 排除出通知过或者没有通知方式的得意先
      noticedDyx = noticedDyx.filter(function (dyx) {
        if (!dyx.noticeType) {
          return false;
        } else if (dyx.noticeDate) {
          return false;
        }
        return true;
      });
      this.noticeProduct(noticedDyx);
    },
    /**
     * 批量通知弹窗 取消
     * @return {[type]} [description]
     */
    moreNoticeCancel: function moreNoticeCancel() {
      this.moreNoticeVisible = false;
    },
    /**
     * 通知得意先
     * @return {[type]} [description]
     */
    noticeProduct: function noticeProduct(noticeDyxList) {
      var _this2 = this;
      this.$refs.searchForm.validate(function (success, values) {
        if (success) {
          console.log('values', values);

          // this.noticeLoading = true
          _this2.requstSaveNotice().then(function (res) {
            if (res.code === 200) {
              console.log('noticeProduct', res);
              if (_.isObject(res.data)) {
                _this2.queryParam.noticeId = res.data.noticeId;
                _this2.getNoticeData();
                _this2.requestNotice(res.data.noticeId, noticeDyxList).then(function (res) {
                  return res.data;
                }).then(function (res) {
                  if (res.code === 200) {
                    _this2.$message.success(_this2.$t('arrivalNotice.noticeSuccess'));
                    _this2.moreNoticeVisible = false;
                    _this2.selectCustomerList = [];
                    _this2.selectedRowKeys = [];
                    _this2.getNoticeData();
                  } else {
                    // this.$message.error(res.message)
                  }
                });
              } else {
                console.warn('保存到货通知接口返回的数据不是对象', res);
              }
            } else {
              // this.$message.success(res.message)
            }
          }).finally(function () {
            _this2.noticeLoading = false;
          });
        }
      });
    },
    requestNotice: function requestNotice(noticeId, noticeDyxList) {
      var _this3 = this;
      var params = {
        erpCustomerids: []
      };
      if (noticeDyxList && noticeDyxList.length > 0) {
        params.erpCustomerids = noticeDyxList.map(function (dyx) {
          return dyx.erpCustomerId;
        });
      }
      if (this.noticeDyxLoading) return;
      this.noticeDyxLoading = true;
      return noticeDyx(noticeId, params).finally(function () {
        _this3.noticeDyxLoading = false;
      });
    },
    /**
     * 保存通知设置
     * @return {[type]} [description]
     */
    saveNotice: function saveNotice() {
      var _this4 = this;
      console.log('clicked');
      this.$refs.searchForm.validate(function (success, values) {
        console.log({
          success: success,
          values: values
        });
        if (success) {
          console.log('values', values);

          // this.noticeSaveLoading = true //TODO 临时注释, 记得恢复
          _this4.requstSaveNotice().then(function (res) {
            if (res.code === 200) {
              _this4.queryParam.noticeId = res.data.noticeId;
              _this4.$message.success(_this4.$t('public.saveSuccessfully'));
              _this4.getNoticeData();
            } else {
              // this.$message.success(res.message)
            }
          }).finally(function () {
            _this4.noticeSaveLoading = false;
          });
        }
      });
    },
    /**
     * 请求保存通知设置
     * @return {[type]} [description]
     */
    requstSaveNotice: function requstSaveNotice() {
      var _this5 = this;
      var params = {
        /**
         * 通知id，新建时传空
         */
        id: this.queryParam.noticeId,
        /**
         * 通知名称
         */
        noticeName: this.queryParam.noticeName,
        page: 1,
        size: 10
      };
      // 商品列表
      if (this.productList && this.productList.length > 0) {
        params.productlist = this.productList.map(function (p) {
          return p.productOptionId;
        });
      } else {
        this.$message.warning(this.$t('arrivalNotice.productTip'));
        return;
      }
      // 担当者id和担当者名称
      if (this.queryParam.selllerCode && this.queryParam.selllerCode.length > 0) {
        var selllerCodes = this.queryParam.selllerCode;
        var sellerNames = selllerCodes.map(function (code) {
          var seller = _this5.sellerOptions.find(function (item) {
            return item.sellerCode === code;
          });
          return seller.sellerName;
        });
        console.log('sellerNames', sellerNames);
        params.selllerName = sellerNames.join(',');
        params.selllerCode = selllerCodes.join(',');
      }
      if (this.dyxList && this.dyxList.length <= 0) {
        this.$message.warning(this.$t('arrivalNotice.customerTip'));
        return;
      }
      // 得意先列表
      params.erpcustomerlist = [];
      if (this.dyxList && this.dyxList.length > 0) {
        this.dyxList.forEach(function (dyx) {
          params.erpcustomerlist.push({
            id: dyx.id,
            erpcustomerId: dyx.erpCustomerId
            // deletflag: dyx.deletflag ? 1 : 0
          });
        });
      } else {
        this.$message.warning(this.$t('arrivalNotice.customerTip'));
        return;
      }
      this.noticeSaveLoading = true;
      return saveNoticeSetting(params).then(function (res) {
        return res.data;
      }).finally(function () {
        _this5.noticeSaveLoading = false;
      });
    },
    // 批量删除取消
    removeModalCancel: function removeModalCancel() {
      this.removeTypeVisible = false;
    },
    // 过滤出通知过的得意先
    handleCustomerList: function handleCustomerList(data) {
      return data.filter(function (dyx) {
        return !dyx.noticeDate;
      });
    },
    removeClick: function removeClick() {
      // this.dialogStatus = 'batchinvalid'
      this.modalValue.removeType = 0;
      this.removeTypeVisible = true;
    },
    /**
     * 通知对象表格 选择change
     * @param  {[type]} selectedRowKeys [description]
     * @param  {[type]} selectedRows    [description]
     * @return {[type]}                 [description]
     */
    onNoticeTableChange: function onNoticeTableChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    /**
     * 通知对象表格 选择改变
     * @param  {[type]} record       [description]
     * @param  {[type]} selected     [description]
     * @param  {[type]} selectedRows [description]
     * @return {[type]}              [description]
     */
    onNoticeTableSelect: function onNoticeTableSelect(record, selected, selectedRows) {
      //如果选中，添加进去
      if (selected) {
        this.selectCustomerList = _.concat(this.selectCustomerList, record);
      } else {
        //取消选中，失效
        this.selectCustomerList = _.remove(this.selectCustomerList, function (o) {
          return o.erpCustomerId != record.erpCustomerId;
        });
      }
    },
    /**
     * 通知对象表格 选择全部
     * @param  {[type]} selected     [description]
     * @param  {[type]} selectedRows [description]
     * @param  {[type]} changeRows   [description]
     * @return {[type]}              [description]
     */
    onNoticeTableSelectAll: function onNoticeTableSelectAll(selected, selectedRows, changeRows) {
      var _this6 = this;
      if (selected) {
        this.selectCustomerList = _.concat(this.selectCustomerList, changeRows);
      } else {
        changeRows.forEach(function (item) {
          //取消选中，失效
          _this6.selectCustomerList = _.remove(_this6.selectCustomerList, function (o) {
            return o.erpCustomerId != item.erpCustomerId;
          });
        });
      }
    },
    /**
     * 添加得意先
     */
    addNoticeDyx: function addNoticeDyx() {
      var _this7 = this;
      this.$nextTick(function () {
        _this7.$refs.selectModal.visible = true;
      });
    },
    /**
     * 选择得意先弹窗确定
     * @param  {array} data 添加得意先弹窗返回的得意先数组
     * @return {void}
     */
    confirmProduct: function confirmProduct(data) {
      var _this8 = this;
      console.log(data, 'data......');
      if (!_.isArray(data)) {
        console.warn('添加得意先弹窗是数据不是数组 data=', data);
        return;
      }
      /*
      比较 弹窗和现有的,
      如果 如果弹窗比现有的少,说明有得意先被移除了, 需要从现有的data中找出来,
          如果这个得意先的id 为空, 说明没有保存过,直接移除
          如果这个得意先的id不为空,说明被保存过,就设置deletflag
      如果弹窗比现有的多
      例如:
      noticeTableData: 1 2 3 4
      data:            1   5 6
      其中: 2 是删除的 5 6 是新增的
         */
      var removedCustomers = _.differenceBy(this.dyxList, data, 'erpCustomerId');
      var addedCustomers = _.differenceBy(data, this.dyxList, 'erpCustomerId');
      var tableData = this.dyxList;

      /**
       *
       */
      var _iterator = _createForOfIteratorHelper(removedCustomers),
        _step;
      try {
        var _loop2 = function _loop2() {
          var customer = _step.value;
          var findCustomer = tableData.find(function (source) {
            return source.erpCustomerId === customer.erpCustomerId;
          });
          if (findCustomer) {
            // 如果这个得意先是通知过的, 不删除
            if (findCustomer.noticeDate) {
              return 1; // continue
            }
            // 否则 直接移除
            tableData = tableData.filter(function (source) {
              return source.erpCustomerId === findCustomer.erpCustomerId;
            });
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          if (_loop2()) continue;
        }

        // 最新的table data
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var newTableData = [].concat(_toConsumableArray(addedCustomers), _toConsumableArray(tableData));

      // 根据最新的table data 获取通知方式
      var params = {
        newErpCustomerid: newTableData.map(function (dyx) {
          return dyx.erpCustomerId;
        }).join(',')
      };
      getNoticeSetting(this.queryParam.id || 0, params).then(function (res) {
        return res.data;
      }).then(function (res) {
        if (res.code === 200) {
          if (_.isObject(res.data)) {
            var erpcustomerlist = res.data.erpcustomerlist || [];

            // 赋值通知方式
            if (erpcustomerlist) {
              var _iterator2 = _createForOfIteratorHelper(erpcustomerlist),
                _step2;
              try {
                var _loop = function _loop() {
                  var dyx = _step2.value;
                  var customer = newTableData.find(function (c) {
                    return c.erpCustomerId === dyx.erpCustomerId;
                  });
                  if (customer) {
                    customer.noticeType = dyx.noticeType;
                  }
                };
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  _loop();
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
            _this8.dyxList = newTableData;
            _this8.alreadySelect = newTableData.map(function (item) {
              return item.erpCustomerId;
            });
            _this8.listTotal = _this8.dyxList.length;
            _this8.crrentPageProductList = _this8.dyxList.slice(0, _this8.queryParam.size);
          } else {
            console.warn('添加得意先时获取的通知方式数据不能为空 res', res);
          }
        }
      });
    },
    noticeTableChange: function noticeTableChange(pagination, filters, sorter, _ref) {
      var currentDataSource = _ref.currentDataSource;
      this.queryParam.page = pagination.current;
      this.queryParam.size = pagination.pageSize;
      var newlist = _.cloneDeep(this.dyxList);
      //初始肯定是第一页，那么需要截取第一页的数据
      this.crrentPageProductList = newlist.splice((this.queryParam.page - 1) * this.queryParam.size, this.queryParam.size);
    },
    /**
     * 点击删除商品
     * @param  {object} product 删除的商品数据
     * @return {void}
     */
    deleteProduct: function deleteProduct(product) {
      this.productList = this.productList.filter(function (p) {
        return p.productOptionId !== product.productOptionId;
      });
    },
    /**
     * 点击添加商品按钮
     */
    addProduct: function addProduct() {
      this.addProductVisible = true;
    },
    //添加商品弹窗 取消
    resetFormDate: function resetFormDate() {
      this.addProductVisible = false;
      this.datavalue.id = undefined;
    },
    //添加商品弹窗 保存
    addNew: function addNew() {
      var _this9 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          //调接口
          _this9.addProudctSaveLoading = true;
          var params = {
            condition: {},
            productOpitonIdStr: _this9.datavalue.id + ''
          };
          getProductList(params).then(function (res) {
            console.log('res', res);
            if (res.data.code === 200) {
              if (res.data.data && res.data.data.list) {
                var product = res.data.data.list[0];
                if (product) {
                  // 判断productList
                  if (!_.isArray(_this9.productList)) {
                    console.log('productList', _this9.productList);
                    throw new Error('productList 不是数组类型');
                  }
                  // 判断改商品是不是已经添加过
                  var presenceProduct = _this9.productList.find(function (p) {
                    return p.productOptionId === product.optionId;
                  });
                  if (presenceProduct) {
                    _this9.$message.warning(_this9.$t('arrivalNotice.sameProductTip'));
                    return;
                  }
                  var addedProudct = {
                    productOptionId: product.optionId,
                    productNo: product.productNo,
                    productName: product.productName,
                    productOptionName: product.specValueName
                  };
                  _this9.productList = [].concat(_toConsumableArray(_this9.productList), [addedProudct]);
                  _this9.$message.success(_this9.$t('arrivalNotice.addsuccess'));
                  _this9.addProductVisible = false;
                } else {
                  throw new Error('添加商品失败, 没有获取到商品 res', res);
                }
              } else {
                console.warn('添加商品失败, 没有回获取到商品 res', res);
              }
            }
          }).finally(function () {
            _this9.addProudctSaveLoading = false;
            _this9.addProudctList = null;
            _this9.resetFormDate();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
     * 添加商品弹窗 搜索商品
     * @param  {string} value 搜索的值
     * @return {void}
     */
    handleSearch: function handleSearch(value) {
      var self = this;
      self.addProudctList = null;
      self.addProductFetching = true;

      //获取列表
      if (value != null && value.length > 0) {
        getSpecDetailList(value, 1).then(function (res) {
          //         console.log(res.data)
          if (res.data.code === 200) {
            if (_.isObject(res.data)) {
              self.addProudctList = res.data.data || [];
              self.addProductFetching = false;
            } else {
              console.warn('搜索商品弹窗返回的数据不是对象 res', res);
            }
          } else {
            // self.$notification.error({ message: res.data.message })
          }
        });
      }
    },
    handleChange: function handleChange(value) {
      //          console.log(value);
      this.datavalue.id = value;
    },
    /**
     * 获取担当者列表
     * @return {void}
     */
    getSellerListData: function getSellerListData() {
      var _this0 = this;
      getSellerList({
        type: 1
      }).then(function (res) {
        if (res.data.code === 200) {
          if (_.isObject(res.data)) {
            _this0.sellerOptions = res.data.data || [];
          } else {
            console.warn('获取担当者列表返回的数据不是对象 res', res);
          }
        }
      });
    }
  }
};